import React from "react";
import { cn } from "utils";

// color = "primary" | "white"
const Select = React.forwardRef(
  (
    {
      options = [],
      className,
      selectClass,
      containerClasses,
      fullWidth = false,
      label,
      placeholder = "Select",
      color = "primary",
      error = false,
      errorText = "",
      ...rest
    },
    ref
  ) => {
    return (
      <div
        className={cn(
          "select-container",
          fullWidth ? "full" : "",
          containerClasses
        )}
      >
        {label && <label>{label}</label>}
        <select
          ref={ref}
          defaultValue=""
          className={cn(
            selectClass ? selectClass : "select-base",
            color,
            error ? "error" : "",
            className
          )}
          {...rest}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((option) => {
            return <option value={option?.value}>{option?.label}</option>;
          })}
        </select>
        {errorText && <p className="error-text">{errorText}</p>}
      </div>
    );
  }
);

Select.displayName = "Select";

export default Select;
